import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TokenInterceptor } from './interceptors/token-interceptor.service';
import { SessionGuard } from './guards/session.guard';
import { ErrorInterceptor } from './interceptors/error-interceptor.service';
import { DocPopupComponent } from './components/popups/popup.component';
import { MaterialComponentsModule } from '../shared/material/material.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        PageNotFoundComponent,
        DocPopupComponent,  
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MaterialComponentsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [
       
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        SessionGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        
    ],
})
export class CoreModule { }
